<template>
    <section class="config-section">
        <header class="config-section__header">
            <h2 class="config-section__title">
                {{ title }}
                <span v-if="count !== null" class="config-section__count">({{ count }})</span>
                <span v-if="required" class="config-section__required" aria-hidden="true">*</span>
            </h2>
            <button type="button" class="config-section__toggle" :aria-expanded="open ? 'true' : 'false'" :aria-label="title" @click="open = !open">
                <i class="i-andy-s" :class="open ? 'i-andy-chevron-down' : 'i-andy-chevron-up'" aria-hidden="true"></i>
            </button>
        </header>
        <div v-show="open" class="config-section__content">
            <slot></slot>
        </div>
    </section>
</template>

<script>
export default {
    name: 'ConfigSection',
    props: {
        title: { type: String, required: true },
        required: { type: Boolean, default: false },
        count: { type: Number, default: null }
    },
    data() {
        return {
            open: true
        }
    }
}
</script>

<style lang="scss" scoped>
@import '~@/components/domain/phu-production/styles/tokens';

.config-section {
    @include display-flex();
    @include flex-direction(column);
    gap: 16px;

    &__header {
        @include display-flex();
        @include align-items(center);
        @include justify-content(space-between);
        padding: 4px 8px;
        border-radius: $phu-radius-s;
        background-color: $default-sec-color;
    }

    &__title {
        margin: 0;
        font-family: $text-bold;
        font-size: 1.25rem;
        line-height: 24px;
        color: $phu-text;
    }

    &__required {
        color: $phu-error;
    }

    &__toggle {
        @include display-flex();
        @include align-items(center);
        @include justify-content(center);
        padding: 8px;
        border: none;
        border-radius: $phu-radius-s;
        background-color: $phu-button;
        color: $phu-primary;
        cursor: pointer;
    }

    &__content {
        @include display-flex();
        @include flex-direction(column);
        gap: 16px;
    }
}
</style>
